import * as Actions from "../../store/actions";

import Button from "antd/lib/button";
import Directories from "../../components/directories";
import Form from "antd/lib/form";
import FormRef from "antd/lib/form";
import Input from "antd/lib/input";
import KeyOutlined from "@ant-design/icons/KeyOutlined";
import MainLayout from "../../hoc/main-layout";
import { PropsTypes } from "../types";
import { SignModalProvider } from "../../contexts/sign-modal/index.context";
import Space from "antd/lib/space";
import { StateTypes } from "../../store/types";
import Tabs from "antd/lib/tabs";
import type { TabsProps } from "antd/es/tabs";
import Tooltip from "antd/lib/tooltip";
import { TranslationProvider } from "../../contexts/translation/index.context";
import Typography from "antd/lib/typography";
import User from "../../services/user";
import { connect } from "react-redux";
import { generatePassword } from "../../services/generate-password";
import message from "antd/lib/message";
import { request } from "../../services";
import styles from "./styles.module.scss";
import { translate } from "../../translation";
import { useLocation } from "react-router-dom";
import { useState } from "react";

// import CreateFolderForm from "../../components/forms/profile";
// import Modal from "../../components/ui/modal";



//Components

//UI


//Icons

const enum ErrorCode {
  passwordNotFound = "PASSWORD_NOT_FOUND",
  notFound = "NOT_FOUND",
  unexpectedError = "UNEXPECTED",
  invalid = "INVALID",
  unauthorized = "UNAUTHORIZED",
}


const { Title } = Typography;

function Profile(props: PropsTypes) {
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const [form] = FormRef.useForm();
  const currentUser = User.decode();
  const fullName = `${currentUser?.clerk[0].lastName} ${
    currentUser?.clerk[0].firstName
  } ${currentUser?.clerk[0].middleName ?? ""}`;

  const intl = (selector: string) => {
    return translate(selector, props.lang ?? "uk");
  };

  const onGeneratePassword = () => {
    const newPassword = generatePassword();
    form.setFieldsValue({ newPassword: newPassword });
  };

  const onFinish = async (values: any) => {
    try {
      setLoading(true);
  
      const response = await request(`${location.pathname}/updatepassword`, {
        method: "post",
        body: values,
        cancelTokenKey: "updatepassword",
      });
  
      // Якщо сервер повернув успішну відповідь
      if (response.success) {
        message.success(intl("your-data-has-been-successfully-updated"));
        form.resetFields();
      } else if(!response.success && response.error === ErrorCode.passwordNotFound) {

        message.error(intl("password-wrong"));
      } else {

        message.error(intl("another-wrong"));
      }
    } catch (error) {
      console.error("Помилка при оновленні пароля:", error);
      message.error(intl("something-went-wrong"));
    } finally {
      setLoading(false);
    }
  };
  

  const onFinishFailed = async (errorInfo: any) => {
    console.log("Failed:", errorInfo);
    message.error(intl("please-correct-form-errors"));
  };

  const items: TabsProps["items"] = [
    {
      key: "1",
      label: intl("personal-info"),
      children: (
        <Space className={styles["forms-space"]} align="start" size={"large"}>
          <Space direction="vertical">
            <Form
              name="info-form"
              layout="vertical"
              // onFinish={onInfoFinish}
              // onFinishFailed={onFinishFailed}
              autoComplete="off"
            >
              <Form.Item
                name="login"
                label={intl("login")}
                initialValue={currentUser?.login}
              >
                <Input type="text" disabled={true} />
              </Form.Item>
              <Form.Item
                name="fullName"
                label={intl("full-name-pib")}
                initialValue={fullName}
              >
                <Input type="text" disabled={true} />
              </Form.Item>
              <Form.Item
                name="email"
                label={intl("mail")}
                initialValue={currentUser?.email}
              >
                <Input type="text" disabled={true} />
              </Form.Item>

              <Form.Item label={intl("role")}>
                <Input
                  defaultValue={currentUser?.role[0].roleName}
                  disabled={true}
                />
              </Form.Item>
            </Form>
          </Space>
          <Space direction="vertical">
            <Form
              className={styles["form"]}
              name="password-form"
              layout="vertical"
              // form={form}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
            >
              <Form.Item
                name="currentPassword"
                label={intl("current-password")}
                rules={[
                  {
                    required: true,
                    message: intl("current-password-required"),
                  },
                ]}
              >
                <Input.Password />
              </Form.Item>
              <Space align="start">
                <Form.Item
                  className={styles["new-password"]}
                  name="newPassword"
                  label={intl("new-password")}
                  rules={[
                    {
                      required: true,
                      message: intl("password-required"),
                    },
                    {
                      pattern:
                        /(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z!@#$%^&*_]{8,}/g,
                      message: intl("input-correct-password"),
                    },
                  ]}
                  validateTrigger="onSubmit"
                >
                  <Input.Password />
                </Form.Item>
                <Form.Item label=" ">
                  <Tooltip title={intl("generate-password")}>
                    <Button onClick={onGeneratePassword}>
                      <KeyOutlined />
                    </Button>
                  </Tooltip>
                </Form.Item>
              </Space>
              <Form.Item
                name="confirmNewPassword"
                label={intl("confirm-password")}
                rules={[
                  {
                    required: true,
                    message: intl("confirm-password-required"),
                  },
                  {
                    pattern:
                      /(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z!@#$%^&*_]{8,}/g,
                    message: intl("input-correct-password"),
                  },
                  ({ getFieldValue }) => ({
                    validator(rule, value) {
                      if (!value || getFieldValue("newPassword") === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(intl("confirm-password-reference"));
                    },
                  }),
                ]}
                validateTrigger="onSubmit"
              >
                <Input.Password />
              </Form.Item>

              <Form.Item className={styles["button-item"]}>
                <Button
                  className={styles["button"]}
                  htmlType="submit"
                  loading={loading}
                >
                  {intl("update-data")}
                </Button>
              </Form.Item>
            </Form>
          </Space>
        </Space>
      ),
    },
    {
      key: "2",
      label: intl("menu-tabs"),
      children: <Directories url="/profile/menu-tabs" />,
    },
  ];

  return (
    <MainLayout activeLink={window.location.pathname}>
      <TranslationProvider lang={props.lang}>
        <SignModalProvider>
          <Tabs defaultActiveKey="1" items={items} />
          {/* <Space className={styles["profile-space"]} direction="vertical">
          <Modal okText={intl("ok")} name={intl("create-folder")} form={form}>
            <CreateFolderForm intl={intl} url={location.pathname} form={form} />
          </Modal>
        </Space> */}
        </SignModalProvider>
      </TranslationProvider>
    </MainLayout>
  );
}

function mapStateToProps(state: StateTypes) {
  return {
    lang: state.lang?.value,
    message: state.authLayout?.value,
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    changeLanguage: (language: string) =>
      dispatch({ type: Actions.CHANGE_LANGUAGE, language }),
    closeMessage: () => dispatch({ type: Actions.CLOSE_MESSAGE }),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Profile);
